import { useEffect } from 'react';

export type EventHandler = (this: GlobalEventHandlers, ev: Event) => any;
export type Attribute = [string, string | EventHandler];
export type Tag = Attribute[];

function setScriptTag({
  attributes,
  container,
}: {
  attributes: Tag;
  container: HTMLElement;
}) {
  const script = document.createElement('script');

  attributes.forEach(([attribute, val]) => {
    if (attribute === 'text') {
      const inlineScript = document.createTextNode(val as string);

      script.appendChild(inlineScript);
    } else if (attribute === 'onload') {
      script.onload = val as EventHandler;
    } else {
      script.setAttribute(attribute, val as string);
    }
  });

  container?.appendChild(script);

  return { script };
}

/*
    * This hook is used to load external scripts into the DOM.
    * It requires script tags to be passed using the following format:
    *   const optimizelyScript: Attribute[] = [
        ['defer', 'true'],
        ['src', 'https://optimizely-edge.com/edge-client/v1/7803129/19211830082'],
        ['referrerpolicy', 'no-referrer-when-downgrade'],
    ];
*/
export function useScriptTags({ tags }: { tags: Tag[] }) {
  useEffect(() => {
    const body = document.querySelector('body') as HTMLBodyElement;

    const scripts = tags.map((tag) =>
      setScriptTag({ attributes: tag, container: body }),
    );

    return () => scripts.forEach(({ script }) => body?.removeChild(script));
  }, []);
}
